module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " weex-ct weex-div",
    style: (_vm._px2rem(_vm.mrTimeWrapStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "time-dot-wrap weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm.tplIndexOfDays !== -1) ? _c('div', {
    staticClass: " weex-ct weex-div",
    style: (_vm._px2rem(_vm.mrTimeBoxStyle, 75)),
    attrs: {
      "accessible": true,
      "aria-label": ((_vm.countDownData.day) + "天"),
      "weex-type": "div"
    }
  }, [_c('p', {
    staticClass: " weex-el weex-text",
    style: (_vm._processExclusiveStyle(_vm.mrTimeTextStyle, 75, 'text')),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.countDownData.day))])]) : _vm._e(), _vm._v(" "), (_vm.tplIndexOfDays !== -1) ? _c('div', {
    staticClass: " weex-ct weex-div",
    style: (_vm._px2rem(_vm.mrDotBoxStyle, 75)),
    attrs: {
      "aria-hidden": true,
      "weex-type": "div"
    }
  }, [_c('p', {
    staticClass: " weex-el weex-text",
    style: (_vm._processExclusiveStyle(_vm.mrDotTextStyle, 75, 'text')),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.getDot(_vm.tplIndexOfDays, _vm.tplIndexOfHours)))])]) : _vm._e(), _vm._v(" "), (_vm.tplIndexOfHours !== -1) ? _c('div', {
    staticClass: " weex-ct weex-div",
    style: (_vm._px2rem(_vm.mrTimeBoxStyle, 75)),
    attrs: {
      "accessible": true,
      "aria-label": ((_vm.countDownData.hour) + "时"),
      "weex-type": "div"
    }
  }, [_c('p', {
    staticClass: " weex-el weex-text",
    style: (_vm._processExclusiveStyle(_vm.mrTimeTextStyle, 75, 'text')),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.countDownData.hour))])]) : _vm._e(), _vm._v(" "), (_vm.tplIndexOfHours !== -1) ? _c('div', {
    staticClass: " weex-ct weex-div",
    style: (_vm._px2rem(_vm.mrDotBoxStyle, 75)),
    attrs: {
      "aria-hidden": true,
      "weex-type": "div"
    }
  }, [_c('p', {
    staticClass: " weex-el weex-text",
    style: (_vm._processExclusiveStyle(_vm.mrDotTextStyle, 75, 'text')),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.getDot(_vm.tplIndexOfHours, _vm.tplIndexOfMinutes)))])]) : _vm._e(), _vm._v(" "), (_vm.tplIndexOfMinutes !== -1) ? _c('div', {
    staticClass: " weex-ct weex-div",
    style: (_vm._px2rem(_vm.mrTimeBoxStyle, 75)),
    attrs: {
      "accessible": true,
      "aria-label": ((_vm.countDownData.minute) + "分"),
      "weex-type": "div"
    }
  }, [_c('p', {
    staticClass: " weex-el weex-text",
    style: (_vm._processExclusiveStyle(_vm.mrTimeTextStyle, 75, 'text')),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.countDownData.minute))])]) : _vm._e(), _vm._v(" "), (_vm.tplIndexOfMinutes !== -1) ? _c('div', {
    staticClass: " weex-ct weex-div",
    style: (_vm._px2rem(_vm.mrDotBoxStyle, 75)),
    attrs: {
      "aria-hidden": true,
      "weex-type": "div"
    }
  }, [_c('p', {
    staticClass: " weex-el weex-text",
    style: (_vm._processExclusiveStyle(_vm.mrDotTextStyle, 75, 'text')),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.getDot(_vm.tplIndexOfMinutes, _vm.tplIndexOfSeconds)))])]) : _vm._e(), _vm._v(" "), (_vm.tplIndexOfSeconds !== -1) ? _c('div', {
    staticClass: " weex-ct weex-div",
    style: (_vm._px2rem(_vm.mrTimeBoxStyle, 75)),
    attrs: {
      "accessible": true,
      "aria-label": ((_vm.countDownData.second) + "秒"),
      "weex-type": "div"
    }
  }, [_c('p', {
    staticClass: " weex-el weex-text",
    style: (_vm._processExclusiveStyle(_vm.mrTimeTextStyle, 75, 'text')),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.countDownData.second))])]) : _vm._e(), _vm._v(" "), (_vm.tplIndexOfSeconds !== -1) ? _c('div', {
    staticClass: " weex-ct weex-div",
    style: (_vm._px2rem(_vm.mrDotBoxStyle, 75)),
    attrs: {
      "aria-hidden": true,
      "weex-type": "div"
    }
  }, [_c('p', {
    staticClass: " weex-el weex-text",
    style: (_vm._processExclusiveStyle(_vm.mrDotTextStyle, 75, 'text')),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.getDot(_vm.tplIndexOfSeconds, -1)))])]) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4d80d8ac", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d80d8ac","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-countdown/index.vue
// module id = 617
// module chunks = 0 1